import { render, staticRenderFns } from "./GeneralSpecialtyEdit.vue?vue&type=template&id=25c226d8&scoped=true&"
import script from "./GeneralSpecialtyEdit.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c226d8",
  null
  
)

export default component.exports